<template>
  <div class="market-trade-sell">
    <div class="trade-field">
      <span class="trade-field-label">Harga</span>
      <!-- eslint-disable -->
      <input
        v-if="isFormatNumber == false"
        type="text"
        v-model="sellForm.price"
        class="trade-field-input"
        v-clear-zero
        @blur="formatPrice"
        @keyup="onPriceKeyup"
        @click="handleClick"
        placeholder="0"
      />
      <input
        v-else
        type="text"
        v-model="idrFormat"
        class="trade-field-input"
        @click="handleClick"
      />
      <!-- eslint-enable -->
      <span class="trade-field-unit">{{ simbol_b }}</span>
    </div>

    <div class="trade-field">
      <span class="trade-field-label">Jumlah</span>
      <input
        type="text"
        class="trade-field-input"
        v-model="sellForm.qtyA"
        v-clear-zero
        @keyup="onQtyAKeyup"
        placeholder="0"
      />
      <span class="trade-field-unit">{{ simbol_a }}</span>
    </div>

    <ul class="market-trade-list">
      <li>
        <span
          @click="percentClicked(0.25)"
          class="percent"
          :class="{ active: activePercent === 0.25, disabled: !canUsePercent }"
          >25%</span
        >
      </li>
      <li>
        <span
          @click="percentClicked(0.5)"
          class="percent"
          :class="{ active: activePercent === 0.5, disabled: !canUsePercent }"
          >50%</span
        >
      </li>
      <li>
        <span
          @click="percentClicked(0.75)"
          class="percent"
          :class="{ active: activePercent === 0.75, disabled: !canUsePercent }"
          >75%</span
        >
      </li>
      <li>
        <span
          @click="percentClicked(1)"
          class="percent"
          :class="{ active: activePercent === 1, disabled: !canUsePercent }"
          >100%</span
        >
      </li>
    </ul>

    <div class="trade-field">
      <span class="trade-field-label">Total</span>
      <input
        v-if="!isFormatTotal"
        type="text"
        class="trade-field-input"
        v-model="sellForm.qtyB"
        v-clear-zero
        @keyup="onTotalKeyup"
        @blur="formatTotal"
        @click="handleTotalClick"
        placeholder="0"
      />
      <input
        v-else
        type="text"
        class="trade-field-input"
        v-model="idrTotalFormat"
        @click="handleTotalClick"
      />
      <span class="trade-field-unit">{{ simbol_b }}</span>
    </div>

    <div class="trade-info">
      <div class="trade-info-row">
        <span class="trade-info-label">Tersedia</span>
        <span class="trade-info-value">
          {{ themain.formatBalance(sellForm.tokenAOwned || 0, simbol_a, 8) }}
          {{ simbol_a }}
        </span>
      </div>
      <div class="trade-info-row">
        <span class="trade-info-label">Maks. Jual</span>
        <span class="trade-info-value">
          {{ themain.formatBalance(maxSell, simbol_b, quoteDisplayDecimals) }}
          {{ simbol_b }}
        </span>
      </div>
      <div class="trade-info-row">
        <span class="trade-info-label">Fee</span>
        <span class="trade-info-value">
          {{
            themain.formatBalance(estimatedFee, simbol_b, quoteDisplayDecimals)
          }}
          {{ simbol_b }}
          <small v-if="feePercent">({{ feePercent }}%)</small>
        </span>
      </div>
    </div>

    <button
      v-if="isKycApproved"
      class="btn sell"
      @click="sellBtnClicked"
    >
      Jual {{ simbol_a }}
    </button>
    <KycInProcessLabel v-else-if="isKycPending" block />
    <button
      v-else
      class="btn sell"
      @click="sellBtnClicked"
    >
      Mulai KYC
    </button>
  </div>
</template>

<script>
// node_modules
import Cookies from "js-cookie";

// applibs
import thestore from "@/applibs/thestore.js";
import themain from "@/applibs/themain.js";
import KycInProcessLabel from "@/components/global/KycInProcessLabel.vue";

export default {
  components: { KycInProcessLabel },
  props: {
    marketData: {
      type: Object,
      required: true,
    },
    currencyAObj: {
      type: Object,
    },
    currencyBObj: {
      type: Object,
    },
    handleFormatDisplay: {
      type: Function,
    },
    isFormatNumber: {
      type: Boolean,
    },
    isKycApproved: {
      type: Boolean,
      default: false,
    },
    isKycPending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      themain,

      market_id: this.$route.params.market_id,
      market_pair: this.$route.params.market_pair,

      token: Cookies.get("jwt") || Cookies.get("usid"),

      price_buy: 0,

      simbol_a: "",
      simbol_b: "",

      sellForm: {
        price: 0,
        qtyA: 0,
        qtyB: 0,
        tokenAOwned: 0,
      },

      f_buys: [],
      idrFormat: 0,
      idrTotalFormat: "",
      isFormatTotal: false,

      market_fee: 0,

      submitBtnDisabled: false,
      priceManuallySet: false,
      activePercent: null,
    };
  },

  watch: {
    marketData: {
      handler(market) {
        this.initPriceFromMarket(market);
      },
      deep: true,
    },
  },
  computed: {
    quoteDisplayDecimals() {
      return themain.quoteDecimalPlaces(
        this.simbol_b,
        this.currencyBObj?.decimal_display ?? 2
      );
    },
    canUsePercent() {
      const price = parseFloat(this.sellForm.price) || 0;
      const balance = parseFloat(this.sellForm.tokenAOwned) || 0;
      return price > 0 && balance > 0;
    },
    feePercent() {
      const spread = parseFloat(this.marketData.ticker_percent_spread);
      if (!spread || isNaN(spread)) return "";
      return (spread * 100).toFixed(2);
    },
    maxSell() {
      const price = parseFloat(this.sellForm.price);
      const balance = parseFloat(this.sellForm.tokenAOwned);
      if (!price || price <= 0 || !balance) return 0;
      return balance * price;
    },
    estimatedFee() {
      const total = parseFloat(this.sellForm.qtyB);
      const spread = parseFloat(this.marketData.ticker_percent_spread);
      if (!total || isNaN(total) || !spread) return 0;
      return total * spread;
    },
  },

  async created() {
    var self = this;

    self.emitter.on("fe-ubalances", async function (e) {
      self.ubalances = e.data;
      self.sellForm.tokenAOwned = e.data[self.simbol_a];
      if (self.activePercent !== null) {
        self.applyPercent(self.activePercent);
      }
    });

    self.emitter.on("fe-buys", function (e) {
      self.f_buys = e.data.sort((a, b) => {
        return parseFloat(b.market_position) - parseFloat(a.market_position);
      });
      if (self.f_buys && self.f_buys.length > 0) {
        self.price_buy = self.f_buys[0].market_position;
      } else {
        self.price_buy = 0;
      }
    });

    self.emitter.on("fe-market_update", function (e) {
      if (e.pair === self.market_pair) {
        self.initPriceFromMarket(e.data);
      }
    });

    self.emitter.on("fe-obook_clicked", async function (e) {
      self.priceManuallySet = true;
      self.activePercent = null;
      self.setPrice(parseFloat(e.data.obj.market_position));
      if (e.data.kind == "sell") {
        self.sellForm.qtyA = e.data.obj.market_amount;
      } else {
        var jumlah = 0;
        self.f_buys.forEach((el) => {
          if (
            parseFloat(el.market_position) >=
            parseFloat(e.data.obj.market_position)
          ) {
            jumlah = jumlah + parseFloat(el.market_result_including_fee);
          }
        });
        self.sellForm.qtyA = jumlah;
        self.handleFormatDisplay(false);
        self.idrFormat = jumlah;
      }
      self.totalCalculation();
    });
  },

  async mounted() {
    var self = this;

    var market_pair_arr = self.market_pair.split("_");
    self.simbol_a = market_pair_arr[0];
    self.simbol_b = market_pair_arr[1];

    self.initPriceFromMarket(self.marketData);

    var res = await thestore.getBalances(self.token, 1, 10, "id", "asc", [
      { field: "ccurrency_symbol", op: "equal", value: self.simbol_a },
    ]);

    self.sellForm.tokenAOwned = res.datas[0].saldo_value;
  },

  methods: {
    setPrice(price) {
      const parsed = parseFloat(price) || 0;
      this.sellForm.price = parsed;
      this.idrFormat =
        parsed > 0
          ? themain.formatBalance(
              parsed,
              this.simbol_b,
              this.quoteDisplayDecimals
            )
          : "";
    },
    initPriceFromMarket(market) {
      if (this.priceManuallySet) return;
      const lastPrice = parseFloat(market && market.last_price) || 0;
      this.setPrice(lastPrice);
      if (this.activePercent !== null) {
        this.applyPercent(this.activePercent);
      }
    },
    handleClick() {
      this.handleFormatDisplay(false);
    },
    handleTotalClick() {
      this.isFormatTotal = false;
    },
    onPriceKeyup() {
      this.priceManuallySet = true;
      if (this.activePercent !== null) {
        this.applyPercent(this.activePercent);
      } else {
        this.totalCalculation();
      }
    },
    onQtyAKeyup() {
      this.activePercent = null;
      this.totalCalculation();
    },
    onTotalKeyup() {
      this.activePercent = null;
      this.totalFromTotal();
    },
    async sellBtnClicked() {
      var self = this;

      if (!self.isKycApproved) {
        if (!self.isKycPending) {
          self.emitter.emit("show-kyc-modal");
        }
        return;
      }

      const price = parseFloat(self.sellForm.price);
      const qty = parseFloat(self.sellForm.qtyA);

      if (!price || price <= 0) {
        alert("Mohon masukkan harga yang valid (lebih dari 0).");
        return;
      }
      if (!qty || qty <= 0) {
        alert("Mohon masukkan jumlah yang valid (lebih dari 0).");
        return;
      }
      if (qty > parseFloat(self.sellForm.tokenAOwned)) {
        alert("Saldo tidak mencukupi.");
        return;
      }

      const res = await thestore.postExchange(
        self.token,
        self.market_pair,
        "Limit Sell",
        price,
        qty,
        false
      );

      if (res && res.success === true) {
        self.sellForm.qtyA = 0;
        self.sellForm.qtyB = 0;
        self.activePercent = null;
        self.isFormatTotal = false;
        self.idrTotalFormat = "";
      } else {
        alert((res && res.msg) || "Gagal memasukkan order jual.");
      }

      self.handleFormatDisplay(false);
    },
    formatPrice() {
      this.handleFormatDisplay(true);
      this.idrFormat = themain.formatBalance(
        this.sellForm.price,
        this.simbol_b,
        this.quoteDisplayDecimals
      );
      this.sellForm.price = parseFloat(this.sellForm.price) || 0;
    },
    formatTotal() {
      this.isFormatTotal = true;
      this.idrTotalFormat = themain.formatBalance(
        this.sellForm.qtyB,
        this.simbol_b,
        this.quoteDisplayDecimals
      );
      this.sellForm.qtyB = parseFloat(this.sellForm.qtyB) || 0;
    },
    totalCalculation() {
      const qtyA = parseFloat(this.sellForm.qtyA);
      const price = parseFloat(this.sellForm.price);
      if (!isNaN(qtyA) && !isNaN(price)) {
        this.sellForm.qtyB = qtyA * price;
        this.formatTotal();
      }
    },
    totalFromTotal() {
      const price = parseFloat(this.sellForm.price);
      const total = parseFloat(this.sellForm.qtyB);
      if (price > 0 && !isNaN(total)) {
        this.sellForm.qtyA = total / price;
      }
    },
    floorToDecimals(value, decimals) {
      const factor = Math.pow(10, decimals);
      return Math.floor(value * factor) / factor;
    },
    getEffectivePrice() {
      return parseFloat(this.sellForm.price) || 0;
    },
    applyPercent(percent) {
      const price = this.getEffectivePrice();
      const balance = parseFloat(this.sellForm.tokenAOwned) || 0;
      if (!balance || balance <= 0) {
        return false;
      }

      const amountDecimals = this.currencyAObj?.decimal_display ?? 8;
      const totalDecimals = themain.quoteDecimalPlaces(
        this.simbol_b,
        this.currencyBObj?.decimal_display ?? 8
      );

      let qtyA = balance * percent;
      qtyA = this.floorToDecimals(qtyA, amountDecimals);
      let qtyB = qtyA * price;
      qtyB = this.floorToDecimals(qtyB, totalDecimals);

      this.sellForm.qtyA = qtyA;
      this.sellForm.qtyB = qtyB;
      this.formatTotal();
      return true;
    },
    percentClicked(percent) {
      if (!this.canUsePercent) return;
      this.activePercent = percent;
      this.handleFormatDisplay(false);
      this.applyPercent(percent);
    },
  },
};
</script>

<style scoped>
.trade-field {
  display: flex;
  align-items: center;
  background: #eff2f6;
  border: 1px solid #e0e3eb;
  border-radius: 4px;
  margin-bottom: 10px;
  height: 40px;
  padding: 0 10px;
}

.trade-field-label {
  color: #848e9c;
  font-size: 13px;
  flex-shrink: 0;
  min-width: 52px;
}

.trade-field-input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  text-align: right;
  font-size: 13px;
  color: #4a4a4a;
  font-weight: 300;
  min-width: 0;
}

.trade-field-unit {
  color: #848e9c;
  font-size: 13px;
  flex-shrink: 0;
  margin-left: 8px;
}

.trade-info {
  margin: 12px 0 8px;
}

.trade-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  font-size: 12px;
}

.trade-info-label {
  color: #848e9c;
}

.trade-info-value {
  color: #4a4a4a;
  text-align: right;
}

.trade-info-value small {
  color: #848e9c;
  margin-left: 4px;
}

#dark .trade-field {
  background: #2a2e39;
  border-color: #363c4e;
}

#dark .trade-field-label,
#dark .trade-field-unit {
  color: #848e9c;
}

#dark .trade-field-input {
  color: #eaecef;
}

#dark .trade-info-label {
  color: #848e9c;
}

#dark .trade-info-value {
  color: #eaecef;
}

@media only screen and (max-width: 767px) {
  .market-trade-sell {
    border-left: none !important;
  }
}

#dark .market-trade-list li span.percent {
  background: #2a2e39;
  color: #ffffff;
}

.market-trade-list li span.percent {
  background: #eff2f6;
  color: #4a4a4a;
  font-weight: 300;
  padding: 3px 15px;
  border-radius: 5px;
  cursor: pointer;
}

.market-trade-list li span.percent.active {
  background: #ff666d;
  color: #fff;
}

.market-trade-list li span.percent.disabled {
  opacity: 0.35;
  cursor: not-allowed;
  pointer-events: none;
}

#dark .market-trade-list li span.percent.active {
  background: #ff666d;
  color: #fff;
}

.market-trade-list {
  margin-bottom: 10px;
}

.market-trade button.buy,
.market-trade button.sell {
  margin-top: 4px;
}
</style>
